







































import {Component, Vue} from 'vue-property-decorator';
import {AxiosStatic} from "axios";

@Component
export default class NoOrganisationPanel extends Vue {
	public $http!: AxiosStatic;
	public resourceName: string = '';
	public createOrganisationLoading: boolean = false;

	public login() {
		if (this.resourceName.length == 0) {
			return;
		}

		this.createOrganisationLoading = true;
		let url = '/public/register';
		this.$http.post(url, { 'skipUser': 'true', 'resourceName': this.resourceName })
			.then(() => { location.reload() });
	}
}
